import LedgerBase from './Base.js';
import { LedgerDerivationPathType } from '../../types.js';
export class LedgerLegacy extends LedgerBase {
    constructor(args) {
        super({
            ...args,
            derivationPathType: LedgerDerivationPathType.LedgerMew,
        });
    }
}
